﻿import { InfluxDataWrapper } from "../../InfluxDb/InfluxDataWrapper";
import { MainSite } from "../../MainSite";
import { NoDownloadPermissionDialog } from "./NoDownloadPermissionDialog";
import { PlottingPage } from "./PlottingPage";

export class PlottingToolbar {
    public nav: JQuery;

    private dateRangePicker: JQuery;
    private pngButton: JQuery;
    private downloadCSVButton: JQuery;
    private downloadDLPButton: JQuery;
    private downloadALLButton: JQuery;
    private downloadDataForm: JQuery;
    private button30: JQuery;
    private from: moment.Moment;
    private to: moment.Moment;
    public resolutionSelector: JQuery;
    public groupingSelector: JQuery;
    public dataFunctionSelector: JQuery;
    private $refreshGroup: JQuery;
    private $refreshSel: JQuery;
    private multipleSitesSelected: boolean = false;

    constructor(public mainSite: MainSite, private plottingPage: PlottingPage) {
        this.nav = $('<nav class="navbar navbar-default midi_PlottingPage_secondaryNav"></nav>');
        var navbarContainer = $('<div class="container-fluid"></div>').appendTo(this.nav);

        $(`<div class= "navbar-header">
                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#plottingNavBar" aria-expanded="false">
                <span class= "sr-only">Toggle navigation</span>
                <span class="icon-bar"> </span>
                <span class="icon-bar"> </span>
                <span class="icon-bar"> </span>
                </button>
                </div>`).appendTo(navbarContainer);

        var plottingNavBarCollapse = $('<div class="collapse navbar-collapse" id="plottingNavBar"></div>').appendTo(navbarContainer);
        var plottingNavBarList = $('<ul class="nav navbar-nav midi_PlottingPage_navBar_list"></ul>').appendTo(plottingNavBarCollapse);

        $('<li class="midi_PlottingPage_navBar_listItem"><a>24 Hours</a></li>').click((e: JQueryMouseEventObject) => {
            this.setDateWithButtons(1);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);

        $('<li class="midi_PlottingPage_navBar_listItem"><a>7 Days</a></li>').click((e: JQueryMouseEventObject) => {
            this.setDateWithButtons(7);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);

        $('<li class="midi_PlottingPage_navBar_listItem"><a>14 Days</a></li>').click((e: JQueryMouseEventObject) => {
            this.setDateWithButtons(14);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);

        this.button30 = $('<li class="midi_PlottingPage_navBar_listItem"><a>30 Days</a></li>').click((e: JQueryMouseEventObject) => {
            this.setDateWithButtons(30);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);

        $('<li class="midi_PlottingPage_navBar_listItem"><a>90 Days</a></li>').click((e: JQueryMouseEventObject) => {
            this.setDateWithButtons(90);
            $(e.target).parent().addClass("active");
        }).appendTo(plottingNavBarList);

        var plottingNabBarForm = $('<form class="navbar-form navbar-left"></form>').appendTo(plottingNavBarCollapse);

        var timeZoneString = this.mainSite.getTimeZoneString();

        this.dateRangePicker = $('<div class="input-daterange input-group"><input class="input-sm form-control" type="text" id="midi_PlottingPage_date_picker_from" name="start"><span class="input-group-addon">to</span><input class="input-sm form-control" type="text" id="midi_PlottingPage_date_picker_to" name="end"></div>')
            .appendTo(plottingNabBarForm)
            .datepicker({
                format: "yyyy-mm-dd  " + timeZoneString,
                language: 'en-GB'
            })
            .on('changeDate', (e) => {
                this.from = moment.utc(this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').val(), 'YYYY-MM-DD');
                this.to = moment.utc(this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').val(), 'YYYY-MM-DD').endOf('day').startOf('minute');

                let ymdFrom: string = this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').val().substr(0, 10);
                let ymdTo: string = this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').val().substr(0, 10);

                let mm = this.plottingPage.getMomentsRange(ymdFrom, ymdTo);
                this.from = mm.from;
                this.to = mm.to;

                if (this.plottingPage._debug) {
                    console.info(`%c[PLOT TOOLBAR]`, 'font-weight: bold; color: blue', ` DATEPICKERS CHANGE EVENT... THEN plottingPage.setDateRange(..)`, { e: e, from: this.from, to: this.to, inputs: { f: this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').val(), t: this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').val(), ymdF: ymdFrom, ymdT: ymdTo, mm: mm } });
                }

                //: auto-hide datepicker & move onto 'to' field if appropriate
                $(e.target).blur();
                $(e.target).datepicker('hide');
                if (e.target.id == "midi_PlottingPage_date_picker_from") {
                    this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').focus();
                }

                this.plottingPage.setDateRange(this.from, this.to);
            });
        
        var groupingSelectorContainer = $('<div id = "midi_PlottingPage_groupingSelector_container">Grouping:</div>').appendTo(plottingNavBarCollapse);
        this.groupingSelector = $('<select id="midi_PlottingPage_groupingSelector"></select>').appendTo(groupingSelectorContainer);
        
        $('<option value="high">High</option>').appendTo(this.groupingSelector);
        $('<option value="average">Avg.</option>').appendTo(this.groupingSelector);
        $('<option value="low">Low</option>').appendTo(this.groupingSelector);
    
        this.groupingSelector.change(() => {
            this.plottingPage.setGrouping($("#midi_PlottingPage_groupingSelector").val());
        })

        var dataFunctionSelectorContainer = $('<div id = "midi_PlottingPage_dataFunctionSelector_container">Function:</div>').appendTo(plottingNavBarCollapse);
        this.dataFunctionSelector = $('<select id="midi_PlottingPage_dataFunctionSelector"></select>').appendTo(dataFunctionSelectorContainer);

        $('<option value="none">None</option>').appendTo(this.dataFunctionSelector);
        $('<option value="roc">RoC</option>').appendTo(this.dataFunctionSelector);

        this.dataFunctionSelector.change(() => {
            this.plottingPage.setDataFunction(this.dataFunctionSelector.val());
        })


        // Resolution Selector

        /*var resolutionSelectorContainer = $('<div id = "midi_PlottingPage_resolutionSelector_container">Resolution:</div>').appendTo(plottingNavBarCollapse);
        this.resolutionSelector = $('<select id="midi_PlottingPage_resolutionSelector"></select>').appendTo(resolutionSelectorContainer);
            
        $('<option value=0>Auto</option>').appendTo(this.resolutionSelector);
        $('<option value=-1>All data</option>').appendTo(this.resolutionSelector);
        $('<option value=1>1 min</option>').appendTo(this.resolutionSelector);
        $('<option value=10>10 min</option>').appendTo(this.resolutionSelector);
        $('<option value=60>60 min</option>').appendTo(this.resolutionSelector);
        $('<option value=1440>1 day</option>').appendTo(this.resolutionSelector);
        
        this.resolutionSelector.change(() => {
            this.plottingPage.setResolution(parseInt($("#midi_PlottingPage_resolutionSelector").val(),10));
        })*/

        this.$refreshGroup = $('<div id = "midi_PlottingPage_RefreshSelector_container" class="midi_PlottingPage_Toolbar_SelectGroup"><span>Refresh:</span></div>').appendTo(plottingNavBarCollapse);
        this.$refreshSel = $('<select id="midi_PlottingPage_RefreshSelector" class="midi_PlottingPage_Toolbar_Select"></select>').appendTo(this.$refreshGroup);
        $('<option value="-1">None</option>').appendTo(this.$refreshSel);
        /*
        $('<option value="1">DEV: 1 second</option>').appendTo(this.$refreshSel);
        $('<option value="5">DEV: 5 seconds</option>').appendTo(this.$refreshSel);
        $('<option value="10">DEV: 10 seconds</option>').appendTo(this.$refreshSel);
        $('<option value="20">DEV: 20 seconds</option>').appendTo(this.$refreshSel);
        $('<option value="60">DEV: 1 minute</option>').appendTo(this.$refreshSel);
        */
        $('<option value="300">5 minutes</option>').appendTo(this.$refreshSel);

        this.$refreshSel.change((e) => {
            this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val()));
        });
        this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val()));


        var downloadButtonGroup = $('<div class="btn-group midi_PlottingPage_navbar_button_container navbar-right" role="group" aria-label="...">').appendTo(plottingNavBarCollapse);
        this.downloadDataForm = $('<form method="post" action="api/HistoricalData/Get" enctype="application/x-www-form-urlencoded"></form>').css({ display: 'none' }).appendTo(plottingNavBarCollapse);

        this.pngButton = $('<button title="Download PNG of current plot" class="btn btn-sm navbar-btn btn-default">PNG</button>')
            .appendTo(downloadButtonGroup)
            .click(() => {
            this.plottingPage.downloadPng();
            });

        var downloadPermission = this.plottingPage.checkIfUserCanDownloadRegionData(this.mainSite.selectedRegion.Id);            

        // downloadALLButton
        this.downloadALLButton = $('<button title="Download Data" class="btn btn-sm navbar-btn btn-default"><i class="fa fa-fw fa-download"></i> DOWNLOAD</button>')
            .appendTo(downloadButtonGroup)
            .click(() => {
                if (downloadPermission) {
                    this.plottingPage.downloadDataAllStations();
                }else {
                    new NoDownloadPermissionDialog().show();
                    return false;
                }
            });

        /*
        this.downloadCSVButton = $('<button title="Download CSV of current plot" class="btn btn-sm navbar-btn btn-default">CSV</button>')
            .appendTo(downloadButtonGroup)
            .click(() => {
                if (downloadPermission) {
                    this.downloadData('csv');
                }
                else {
                    new NoDownloadPermissionDialog().show();
                    return false;
                }
        });
        this.downloadDLPButton = $('<button title="Download DLP of current plot" class="btn btn-sm navbar-btn btn-default">DLP</button>')
            .appendTo(downloadButtonGroup)
            .click(() => {
                if (downloadPermission) {
                    if (this.multipleSitesSelected) {
                        new SimpleDialog('DLP disabled for mutliple sites', 'You have selected multiple sites, and DLP files cannot be created based on data from multiple sites. The CSV format is, however, still available.').show();
                    }
                    else {
                        this.downloadData('dlp');
                    }
                }
                else {
                    new NoDownloadPermissionDialog().show();
                    return false;
                }
        });
        */

        var stacked: boolean = false;

        var stackedButton = $('<button id="midi_PlottingPage_stacked" title="Toggle Stacked Plots" class="btn btn-sm btn-default navbar-btn navbar-right">&nbsp;&nbsp;</button>').appendTo(plottingNavBarCollapse)
            .click(
            (e: JQueryEventObject) => {
                if (stacked) {
                    this.plottingPage.setStacked(false);
                    stackedButton.removeClass('stacked');
                    stacked = false;
                } else {
                    this.plottingPage.setStacked(true);
                    stackedButton.addClass('stacked');
                    stacked = true;
                }
            });
    }

    private downloadData(format: string) {
        if (this.plottingPage._debug) {
            console.info(`[PLOT TOOLBAR] downloadData(${format})...`, { format: format });
        }

        var downloadInterval;
        let plot_mm = this.plottingPage.getCurrentMoments();
        this.from = plot_mm.from;
        this.to = plot_mm.to;
        var dateDurationDifferenceInDays = moment.duration(this.to.diff(this.from)).asDays();

        if (dateDurationDifferenceInDays <= 1) {
            downloadInterval = 0;
        }
        else if (dateDurationDifferenceInDays <= 31) {
            downloadInterval = 10;
        }
        else {
            downloadInterval = 60;
        }

        $(".midi_PlottingPage_download_inputs").remove();

        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.from.valueOf() + '" name="From">').appendTo(this.downloadDataForm);
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + this.to.valueOf() + '" name="To">').appendTo(this.downloadDataForm);
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + format + '" name="Format">').appendTo(this.downloadDataForm);
        $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + downloadInterval + '" name="Interval">').appendTo(this.downloadDataForm);

        var anyInputs = false;
        this.plottingPage.plotData.forEach((data_: InfluxDataWrapper) => {
            if (data_) {
                anyInputs = true;
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.Store + '" name="StoreCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.StationId + '" name="SiteCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.SensorId + '" name="SensorCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.ParameterId + '" name="ParameterCols[]">').appendTo(this.downloadDataForm);
                $('<input class="midi_PlottingPage_download_inputs" type="hidden" value="' + data_.VariantId + '" name="VariantCols[]">').appendTo(this.downloadDataForm);
            }
        });
        if (anyInputs) {
            this.downloadDataForm.submit();
            this.downloadDataForm.empty;
        }
    }

    public toggleRefreshOption(enable: boolean = null): void {
        if (enable === null) {
            enable = this.$refreshSel.prop("disabled") ? true : false;
        }

        let tto: TooltipOptions = {
            placement: "bottom"
        };

        if (enable) {
            this.$refreshSel.prop("disabled", false);
            this.$refreshGroup.removeClass("is-disabled");
            this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val()));
            //this.$refreshGroup.tooltip("destroy");
            //tto.title = "Select an auto-refresh rate.";
            //this.$refreshGroup.tooltip(tto);
        } else {
            this.$refreshSel.prop("disabled", true);
            this.$refreshGroup.addClass("is-disabled");
            //this.$refreshGroup.tooltip("destroy");
            //tto.title = "Auto-refresh only available for period ranges that include current and future dates.";
            //this.$refreshGroup.tooltip(tto);
        }
    }

    public click30(): void {
        this.button30.children('a').click();
        if (this.plottingPage._debug) {
            console.info(`[PLOT TOOLBAR] click30()...`);
        }
    }

    public plotDataChanged(): void {
        if (this.plottingPage._debug) {
            console.info(`[PLOT TOOLBAR] plotDataChanged()...`);
        }

        if (this.plottingPage.plotData.length < 1) {
            this.pngButton.attr('disabled', 'disabled');
            //this.downloadCSVButton.attr('disabled', 'disabled');
            //this.downloadDLPButton.attr('disabled', 'disabled');

            return;
        }

        this.pngButton.removeAttr('disabled');
        //this.downloadCSVButton.removeAttr('disabled');
        //this.downloadDLPButton.removeAttr('disabled');

        var firstStation = this.plottingPage.plotData[0].StationId;
        this.multipleSitesSelected = false;

        this.plottingPage.plotData.forEach((value: InfluxDataWrapper) => {
            if (value.StationId !== firstStation) {
                // here we disable the download dlp button, as multiple stations selected
                //  this.downloadDLPButton.attr('disabled', 'disabled');
                this.multipleSitesSelected = true;
            }
        });

        this.plottingPage.refreshIntervalSetTo(parseInt(this.$refreshSel.val())); //: trigger a reset of the auto-refresh interval..
    }

    private setDateWithButtons(numberOfDays: number) {
        var to = moment.utc().tz(this.mainSite.getTimeZoneName()).endOf('day').startOf('minute'); // 23:59 UTC tonight
        var from = moment.utc().tz(this.mainSite.getTimeZoneName()).add(1, 'd').startOf('day').subtract(numberOfDays, 'd'); // 00:00 UTC 30 days ago
        if (this.plottingPage._debug) {
            console.info(`[PLOT TOOLBAR] setDateWithButtons(${numberOfDays})... THEN: this.plottingPage.setDateRange()`, { from: from, to: to });
        }
        this.plottingPage.setDateRange(from, to);
    }

    public dateRangeChanged(from: moment.Moment, to: moment.Moment) {
        if (this.plottingPage._debug) {
            console.info(`[PLOT TOOLBAR] dateRangeChanged(${from}, ${to})... THEN: UPDATE DATEPICKERS`, { from: from, to: to });
        }

        $('.midi_PlottingPage_navBar_listItem').removeClass("active");
        ///this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').datepicker('update', new Date(from.valueOf() + from.toDate().getTimezoneOffset() * 60000));
        ///this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').datepicker('update', new Date(to.valueOf() + to.toDate().getTimezoneOffset() * 60000));
        this.dateRangePicker.find('#midi_PlottingPage_date_picker_from').datepicker('update', from.format("YYYY-MM-DD"));
        this.dateRangePicker.find('#midi_PlottingPage_date_picker_to').datepicker('update', to.format("YYYY-MM-DD"));
        this.dateRangePicker.datepicker('updateDates');

        this.toggleRefreshOption(this.plottingPage.checkRangeHasFuture());
    }
}

 